import React, { FC, PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import useOutsideClickHook from 'app/lib/hooks/useOutsideClickHook';

import DropdownMenuItem from './DropdownMenuItem';

import styles from './DropdownMenu.module.scss';

export type DropdownMenuProps = PropsWithChildren<{
  headerLabel?: string | JSX.Element;
  className?: string;
  onToggle: () => void;
  hideIcon?: boolean;
  isOpen: boolean;
  'data-test'?: string;
}>;

type DropdownMenuComponent = FC<DropdownMenuProps> & {
  Item: typeof DropdownMenuItem;
};

const DropdownMenu: DropdownMenuComponent = ({
  headerLabel,
  children,
  className,
  onToggle,
  hideIcon = false,
  isOpen,
  ...props
}) => {
  const containerRef = useRef(null);

  useOutsideClickHook(containerRef, () => {
    onToggle && onToggle();
  }, isOpen);

  const dropdownContainer = classNames(
    styles.dropdownHeaderLabel,
    className,
  );

  return (
    <div data-test={props['data-test']}
         className={dropdownContainer}
         ref={containerRef}>
      <button className={styles.dropdownHeaderButton}
              onClick={onToggle}>
        {headerLabel}
        {!hideIcon && (
          <Icon icon={isOpen ? 'chevron-up' : 'chevron-down'}
                size={IconSize.DEFAULT}
                className={styles.arrowDown} />
        )}
      </button>
      {isOpen && (
        <ul className={styles.dropdownMenuBody}>
          {children}
        </ul>
      )}
    </div>
  );
};

DropdownMenu.Item = DropdownMenuItem;

export default DropdownMenu;
